import { IAnalyticsModelResponse } from '@kcftech/prometheus-client';
import { DateRelativeToNow } from 'components/date_time/DateRelativeToNow';
import { Detail } from 'components/detail/detail';
import { CollapsiblePane } from 'components/expandable_pane/CollapsiblePane';
import { AnalyticsModelIndicatorsTable } from 'pages/Models/Development/AnalyticsModelIndicatorsTable';
import { ParametersTable } from 'pages/Models/Development/ParametersTable';
import { useState } from 'react';
import styled from 'styled-components';
import { convertDuration } from 'utils/units';

const Header = styled.div`
    font-weight: 500;
    font-size: 3.5rem;
    line-height: 1.26;
`;

export type AnalyticsModelDetailsProps = Readonly<{
    analyticsModel: IAnalyticsModelResponse;
}>;

export function AnalyticsModelDetails({ analyticsModel }: AnalyticsModelDetailsProps) {
    const [parametersPaneOpen, setParametersPaneOpen] = useState(false);
    const [indicatorsPaneOpen, setIndicatorsPaneOpen] = useState(false);

    return (
        <div className="px-35 full-height scrollable-y">
            <Header>{analyticsModel.Name}</Header>
            <div className="py-20">
                <Detail name="Version">{analyticsModel.Version}</Detail>
                <Detail name="Last Upload">
                    <DateRelativeToNow date={analyticsModel.LastUpload} />
                </Detail>
                <Detail name="Creation Date">
                    <DateRelativeToNow date={analyticsModel.Created} />
                </Detail>
                <Detail name="Created By">
                    {analyticsModel.CreatedBy.UserFirstName}{' '}
                    {analyticsModel.CreatedBy.UserLastName}
                </Detail>
                <Detail name="Is Deprecated">
                    {analyticsModel.IsDeprecated ? 'Yes' : 'No'}
                </Detail>
                <Detail name="Time Interval (minutes)">
                    {convertDuration(
                        analyticsModel.TriggerIntervalInSeconds,
                        'seconds',
                        'minutes',
                    )}
                </Detail>
                <CollapsiblePane
                    title="Indicators"
                    expanded={indicatorsPaneOpen}
                    onChange={setIndicatorsPaneOpen}
                    className="mt-20"
                >
                    <AnalyticsModelIndicatorsTable analyticsModel={analyticsModel} />
                </CollapsiblePane>
                <CollapsiblePane
                    title="Parameters"
                    expanded={parametersPaneOpen}
                    onChange={setParametersPaneOpen}
                >
                    <ParametersTable analyticsModel={analyticsModel} />
                </CollapsiblePane>
            </div>
        </div>
    );
}
